import { Typography, Card } from '@mui/material';

export default function Guidelines({ user }) {
    return (
        <Card
            variant='outlined'
            sx={{ padding: 4, marginTop: 4 }}
        >
            <Typography
                variant='h5'
                gutterBottom
            >
                They're more like... Guidelines
            </Typography>
            <Typography
                variant='body1'
                paragraph
            >
                Question Management: You can add, edit,
                or delete quiz questions. Ensure that each
                question is clear and unambiguous.
            </Typography>
            <Typography variant="body1" paragraph>
                Current thoughts on the various question difficulties:
                </Typography>

                {[
                { label: 'Easy', desc: 'Anyone who knows anything about HP could get it. Think about kids' },
                { label: 'Medium', desc: 'Just a little harder than easy' },
                { label: 'Hard', desc: 'Casual fans who may be very rusty still have a good chance' },
                { label: 'Very Hard', desc: 'Kind of obscure. For the real nerds' },
                { label: 'Impossible', desc: 'Go nuts. As obscure as you like' },
                ].map((item) => (
                <Typography
                    key={item.label}
                    sx={{ fontFamily: 'monospace' }}
                >
                    <strong>{item.label.padEnd(10)}</strong> - {item.desc}
                </Typography>
                ))}
            
        </Card>
    );
}
